import React, { Component } from "react";
import { Modal, Button, Form, Spin } from "antd";
import { connect } from "dva";
import FormCreate from "../../../../../components/FormCreate/index";
import styles from "./index.less";

const { FormTitle, ImageUpload, FormTextArea, FormRadioGroup } = FormCreate;

@Form.create()
@connect(({ signRobot }) => ({
  ...signRobot
}))
class RobotModal extends Component {
  componentDidMount() {
    const {
      dispatch,
      nowHaveRobot,
      nowActivityBizId,
      nowActivityOrgId
    } = this.props;
    if (nowHaveRobot) {
      dispatch({
        type: "signRobot/fetchRobotDetail",
        params: {
          activityBizId: nowActivityBizId,
          activityOrgId: nowActivityOrgId
        }
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "signRobot/reset"
    });
  }

  // 创建 || 修改机器人信息
  handleCreateRobot = () => {
    const { form, dispatch, nowActivityBizId, nowActivityOrgId } = this.props;
    const { validateFields } = form;
    if (validateFields) {
      validateFields((errors, values) => {
        if (!errors) {
          dispatch({
            type: "signRobot/fetchCreateRobot",
            params: {
              ...values,
              activityBizIdList: [nowActivityBizId],
              activityOrgIdList: [nowActivityOrgId]
            },
            callback: this.handleCancel
          });
        }
      });
    }
  };

  // 删除机器人
  handleDeleteRobot = () => {
    const { dispatch, nowActivityBizId, nowActivityOrgId } = this.props;
    dispatch({
      type: "signRobot/fetchDeleteRobot",
      params: {
        activityBizId: nowActivityBizId,
        activityOrgId: nowActivityOrgId
      },
      callback: this.handleCancel
    });
  };

  // 取消
  handleCancel = () => {
    const { handleCloseRobotModal } = this.props;
    if (handleCloseRobotModal) {
      handleCloseRobotModal();
    }
  };

  // 弹框底部按钮
  renderModalFooter = () => {
    const { nowHaveRobot } = this.props;
    return (
      <div className="buttonContainer">
        <Button onClick={this.handleCancel}>取消</Button>
        {nowHaveRobot && (
          <Button onClick={this.handleDeleteRobot}>移除机器人</Button>
        )}
        <Button type="primary" onClick={this.handleCreateRobot}>
          确定
        </Button>
      </div>
    );
  };

  // 机器人表单部分渲染
  renderBodyForm = () => {
    const { form, spinProps, formData } = this.props;
    const { spinning, tip } = spinProps;
    const { getFieldsValue } = form;

    const {
      userName,
      avatarGroupId,
      deptName,
      content,
      photoGroupId,
      topFlag,
      squareTopFlag
    } = formData;

    const formCreateProps = {
      customerFormItemLayout: {
        labelCol: {
          xs: { span: 6, offset: 0 },
          sm: { span: 6, offset: 0 },
          md: { span: 6, offset: 0 },
          lg: { span: 6, offset: 0 },
          xl: { span: 6, offset: 0 }
        },
        wrapperCol: {
          xs: { span: 17, offset: 0 },
          sm: { span: 17, offset: 0 },
          md: { span: 17, offset: 0 },
          lg: { span: 17, offset: 0 },
          xl: { span: 17, offset: 0 }
        }
      }
    };

    const sendUserProps = {
      form,
      value: userName,
      label: "发布人名称",
      keyName: "userName",
      maxLength: 20,
      suffix: `${(getFieldsValue().userName &&
        getFieldsValue().userName.length) ||
        0}/20`
    };

    const avatarPropr = {
      form,
      isAvatar: true,
      groupId: avatarGroupId,
      keyName: "avatarGroupId",
      label: "头像",
      selfRules: [
        {
          required: true,
          message: "请设置头像"
        }
      ],
      tips: "说明: 建议尺寸：200*200，最大不可超过5M"
    };

    const deptProps = {
      form,
      value: deptName,
      label: "所在部门",
      keyName: "deptName",
      tips: "说明: 展示发布人所在部门，多部门可用“；”间隔",
      maxLength: 50,
      suffix: `${(getFieldsValue().deptName &&
        getFieldsValue().deptName.length) ||
        0}/50`
    };

    const sendContentPropr = {
      form,
      value: content,
      label: "发布内容",
      keyName: "content",
      maxLength: 500,
      isRequired: true,
      autoSize: { minRows: 5 }
    };

    const photoProps = {
      form,
      groupId: photoGroupId,
      keyName: "photoGroupId"
    };

    const isTopProps = {
      form,
      label: "是否置顶",
      value: topFlag,
      keyName: "topFlag",
      RadioGroupOptions: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      isRequired: true,
      tips: "说明: 置顶后模版动态始终展示活动记录首条"
    };

    const isSquareTopProps = {
      form,
      label: "是否置顶至广场首页",
      value: squareTopFlag,
      keyName: "squareTopFlag",
      RadioGroupOptions: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      isRequired: true,
      tips: "说明: 广场页仅展示置顶至广场页的最新机器人内容"
    };

    return (
      <Spin spinning={spinning} tip={tip}>
        <FormCreate {...formCreateProps}>
          <FormTitle {...sendUserProps} />
          <ImageUpload {...avatarPropr} />
          <FormTitle {...deptProps} />
          <FormTextArea {...sendContentPropr} />
          <ImageUpload {...photoProps} />
          <FormRadioGroup {...isTopProps} />
          <FormRadioGroup {...isSquareTopProps} />
        </FormCreate>
      </Spin>
    );
  };

  render() {
    const { showRobotModal } = this.props;
    const modalProps = {
      wrapClassName: styles["sign-robotModal"],
      width: "100%",
      title: "设置机器人",
      footer: this.renderModalFooter(),
      visible: showRobotModal,
      onCancel: this.handleCancel
    };

    return <Modal {...modalProps}>{this.renderBodyForm()}</Modal>;
  }
}

export default RobotModal;
